export const funFacts = {
  'coral-reef': {
    'default-emojis': '🐢🐙🦀🐠🐟🦈',
    items: [
      {
        emoji: '🏝☀️🌊🌡',
        stringId: 'fun_fact.coral_reef.ideal_temp',
        length: 79,
      },
      {
        emoji: '🎐🙅🏽🧠',
        stringId: 'fun_fact.coral_reef..jellyfish_brains',
        length: 28,
      },
      {
        emoji: '🌏🛰🏝🐚',
        stringId: 'fun_fact.coral_reef.barrier_reef_space',
        length: 95,
      },
      {
        emoji: '🤹‍♂️🎛🎐',
        stringId: 'fun_fact.coral_reef.jellyfish_eyes',
        length: 82,
      },
      {
        emoji: '🏝🐚⏳🎂🎂🎂',
        stringId: 'fun_fact.coral_reef.grow_thousands_years',
        length: 41,
      },
      {
        emoji: '🏝☀️🌊🥤🛢🗑',
        stringId: 'fun_fact.coral_reel.pollution_threat',
        length: 74,
      },
      {
        emoji: '🦈🙇🏽😬',
        stringId: 'fun_fact.coral_reef.human_shark_teeth',
        length: 60,
      },
      {
        emoji: '🐢🦖🦕',
        stringId: 'fun_fact.coral_reef.turtles_110_million',
        length: 93,
      },
      {
        emoji: '🇦🇺🏝🐚🐟🐠🐡🐬🦀🦈🐙🦐',
        stringId: 'fun_fact.coral_reef.barrier_reef_length',
        length: 93,
      },
      {
        emoji: '👴🏽👵🏽🐢🏋🏾‍♀️',
        stringId: 'fun_fact.coral_reef.sea_turtles',
        length: 43,
      },
      {
        emoji: '💥🥊🦐',
        stringId: 'fun_fact.coral_reef..shrimp_punch',
        length: 100,
      },
      {
        emoji: '🌏🐡🐠🐟',
        stringId: 'fun_fact.coral_reef.indopacific_reef',
        length: 91,
      },
    ],
  },
  homes: {
    'default-emojis': '🏘🏬🏢',
    items: [
      {
        emoji: '🇬🇹🐦🇬🇹',
        stringId: 'fun_fact.homes.quetzal',
        length: 47,
      },
      {
        emoji: '🕴🕴🕴👨‍👩‍👦‍👦👨‍👨‍👧‍👧👩‍👩‍👦‍👦',
        stringId: 'fun_fact.homes.seven_billion',
        length: 46,
      },
      {
        emoji: '🗺📍🇲🇳❄️',
        stringId: 'fun_fact.homes.ulaanbaatar',
        length: 85,
      },
      {
        emoji: '🗺📍🇾🇪',
        stringId: 'fun_fact.homes.sanaa',
        length: 77,
      },
      {
        emoji: '😮🇬🇹🤫',
        stringId: 'fun_fact.homes.speaking_loudly',
        length: 64,
      },
      {
        emoji: '⚪️💢⚪️💢⚪️💢⚪️',
        stringId: 'fun_fact.homes.bubble_wrap',
        length: 73,
      },
      {
        emoji: '🇲🇳🙊🤚🏽',
        stringId: 'fun_fact.homes.pointing_fingers',
        length: 58,
      },
      {
        emoji: '🍫🇬🇹',
        stringId: 'fun_fact.homes.guatemala_chocolate',
        length: 77,
      },
      {
        emoji: '🌆🛥🌆🇭🇰🌆🛥🌆',
        stringId: 'fun_fact.homes.hong_kong_boats',
        length: 72,
      },
      {
        emoji: '🇬🇹🚸👶🏻👶🏽👦🏻👦🏽👧🏻 👧🏽🚸🇬🇹',
        stringId: 'fun_fact.homes.guatemala_yemen_kids',
        length: 76,
      },
      {
        emoji: '🇲🇳🎤🎶🎶',
        stringId: 'fun_fact.homes.mongolian_songs',
        length: 34,
      },
      {
        emoji: '⛰⛺️',
        stringId: 'fun_fact.homes.caves',
        length: 33,
      },
      {
        emoji: '🏬🏬🏬🏬🏬🏬',
        stringId: 'fun_fact.homes.row_houses_subdivided',
        length: 101,
      },
      {
        emoji: '🗺📍🇬🇹',
        stringId: 'fun_fact.homes.guatemala_city',
        length: 63,
      },
      {
        emoji: '🐏🏞🇲🇳🌄🐎',
        stringId: 'fun_fact.homes.mongolia_least_populated',
        length: 49,
      },
      {
        emoji: '🎶🇬🇹🎶',
        stringId: 'fun_fact.homes.marimba',
        length: 53,
      },
    ],
  },
  earth: {
    'default-emojis': '🌏🌎🌍🏜🌋⛰🏔🗻🏭',
    items: [
      {
        emoji: '🗻❄️📏',
        stringId: 'fun_fact.earth.glacier_nyc',
        length: 57,
      },
      {
        emoji: '🐚⚰️🏺💀',
        stringId: 'fun_fact.earth.paleontologists_history_life',
        length: 73,
      },
      {
        emoji: '🏝️🌊🏝️🌊🏝️',
        stringId: 'fun_fact.earth.oceans',
        length: 56,
      },
      {
        emoji: '🏝️🌊🌊🏝️',
        stringId: 'fun_fact.earth.seas',
        length: 53,
      },
      {
        emoji: '🌬💨🌊🧘🏻‍♀️🏄🏼‍♂️🌊 ',
        stringId: 'fun_fact.earth.waves',
        length: 25,
      },
      {
        emoji: '🛢️🌊🛢️🌊🛢️🌊🛢️🌊🛢️',
        stringId: 'fun_fact.earth.tons_oil',
        length: 67,
      },
      {
        emoji: '🙏🌏🙏',
        stringId: 'fun_fact.earth.earth_not_greek_name',
        length: 81,
      },
      {
        emoji: '⏫⛰️⏫',
        stringId: 'fun_fact.earth.mountains',
        length: 92,
      },
      {
        emoji: '🦖🦕🌿🌳🐠🐟🐘🐅',
        stringId: 'fun_fact.earth.paleontologists_study',
        length: 70,
      },
      {
        emoji: '🌋🌋🌋🌋🌋',
        stringId: 'fun_fact.earth.volcanoes_explode',
        length: 55,
      },
      {
        emoji: '🌊🏔 🌊',
        stringId: 'fun_fact.earth.surface_land',
        length: 59,
      },
      {
        emoji: '🐌🐛🐜🐝🐞🕷️🦂',
        stringId: 'fun_fact.earth.insects_alive',
        length: 96,
      },
      {
        emoji: '🔥🌶️☕♨️🔴🏮',
        stringId: 'fun_fact.earth.core_hot',
        length: 68,
      },
      {
        emoji: '🌊🏔🌊',
        stringId: 'fun_fact.earth.surface_water',
        length: 60,
      },
      {
        emoji: '🌋🙌🏾🔥',
        stringId: 'fun_fact.earth.vulcan',
        length: 58,
      },
      {
        emoji: '💫🌎⏩🌍⏩🌏 💫',
        stringId: 'fun_fact.earth.travels_space',
        length: 97,
      },
      {
        emoji: '🌏📏👌🏽',
        stringId: 'fun_fact.earth.rotation_varies',
        length: 53,
      },
      {
        emoji: '⛸️💈☃️💈⛸️',
        stringId: 'fun_fact.earth.north_pole',
        length: 46,
      },
      {
        emoji: '🌋🌋🌋🌋🌋',
        stringId: 'fun_fact.earth.active_volcanoes',
        length: 73,
      },
      {
        emoji: '🕳🥄💀',
        stringId: 'fun_fact.earth.fossus',
        length: 71,
      },
      {
        emoji: '🏜🏜🌍',
        stringId: 'fun_fact.earth.sahara',
        length: 82,
      },
      {
        emoji: '🌨️❄️🌍❄️🌎❄️🌏❄️🌨️',
        stringId: 'fun_fact.earth.frozen_planet',
        length: 87,
      },
      {
        emoji: '🌏🌲🌳🌴🌏',
        stringId: 'fun_fact.earth.lose_trees',
        length: 89,
      },
      {
        emoji: '🌲🌳🌴🛤✂️ ',
        stringId: 'fun_fact.earth.deforestation',
        length: 55,
      },
      {
        emoji: '💧🌏💧🇷🇺💧',
        stringId: 'fun_fact.earth.lake_baikal',
        length: 108,
      },
      {
        emoji: '🌏⏬',
        stringId: 'fun_fact.earth.deepest_point',
        length: 100,
      },
      {
        emoji: '🗂🌎🌍🌏🗂',
        stringId: 'fun_fact.earth.4_billion_years',
        length: 42,
      },
      {
        emoji: '⛰️🏞️🌏🇦🇺⏫',
        stringId: 'fun_fact.earth.mount_augustus',
        length: 91,
      },
      {
        emoji: '🌎🌍🌏',
        stringId: 'fun_fact.earth.atlantic_ocean_salty',
        length: 56,
      },
      {
        emoji: '💧💧💧🚰💧💧💧 ',
        stringId: 'fun_fact.earth.drinkable_water',
        length: 59,
      },
      {
        emoji: '🌊 🌕🌖🌗🌘',
        stringId: 'fun_fact.earth.tides',
        length: 56,
      },
      {
        emoji: '🌏📏🔴🥝',
        stringId: 'fun_fact.earth.distance_to_center',
        length: 56,
      },
      {
        emoji: '🦀🍗🍗🍗🍗🍗🍗🐞',
        stringId: 'fun_fact.earth.six_leg_creatures',
        length: 39,
      },
    ],
  },
  'human-body': {
    'default-emojis': '💪🏽🧠👂🏽👄👅👁',
    items: [
      {
        emoji: '👂🏻🔬',
        stringId: 'fun_fact.thb.smallest_bone_ear',
        length: 47,
      },
      {
        emoji: '😬🤟🏽✌🏽',
        stringId: 'fun_fact.thb.32_teeth',
        length: 28,
      },
      {
        emoji: '🧠↩️🧘🏽‍♂️',
        stringId: 'fun_fact.thb.right_controls_left',
        length: 74,
      },
      {
        emoji: '🎾',
        stringId: 'fun_fact.thb.alveoli',
        length: 126,
      },
      {
        emoji: '✋🏽📏🤚🏽',
        stringId: 'fun_fact.thb.distance_fingers_height',
        length: 96,
      },
      {
        emoji: '🌬👁',
        stringId: 'fun_fact.thb.cornea',
        length: 60,
      },
      {
        emoji: '👟📏💪🏽',
        stringId: 'fun_fact.thb.foot_length',
        length: 65,
      },
      {
        emoji: '👀🛌💤',
        stringId: 'fun_fact.thb.eyes_move',
        length: 30,
      },
      {
        emoji: '🤙🏽🏋🏽‍♂️⚖️',
        stringId: 'fun_fact.thb.pinky_strength',
        length: 49,
      },
      {
        emoji: '🤜🍲🌮🥐🥓🥙🥘🎈',
        stringId: 'fun_fact.thb.stomach_expands',
        length: 106,
      },
      {
        emoji: '💇🏽‍♂️💁🏽',
        stringId: 'fun_fact.thb.hair_growth_rate',
        length: 51,
      },
      {
        emoji: '🥚🥚🤰🏽🥚🥚',
        stringId: 'fun_fact.thb.eggs_ovaries',
        length: 71,
      },
      {
        emoji: '🛣️🛣️🛣️🧠🛣️🛣️🛣️',
        stringId: 'fun_fact.thb.neural_pathways',
        length: 67,
      },
      {
        emoji: '☺️🔴🎈',
        stringId: 'fun_fact.thb.stomach_blushes',
        length: 71,
      },
      {
        emoji: '🔬🔴🔵',
        stringId: 'fun_fact.thb.bacteria',
        length: 64,
      },
      {
        emoji: '💓🔊🎶',
        stringId: 'fun_fact.thb.heartbeat_music',
        length: 48,
      },
      {
        emoji: '🌶🍯➰',
        stringId: 'fun_fact.thb.stomach_mucus',
        length: 61,
      },
      {
        emoji: '🌨🍃🌨',
        stringId: 'fun_fact.thb.skin_cells',
        length: 59,
      },
      {
        emoji: '👀💤',
        stringId: 'fun_fact.thb.sleep_eyes_open ',
        length: 39,
      },
      {
        stringId: 'fun_fact.thb.stomach_outside_body',
        length: 89,
      },
      {
        emoji: '👂🏼📈📏',
        stringId: 'fun_fact.thb.ears_grow',
        length: 30,
      },
      {
        emoji: '💀🍗🍖',
        stringId: 'fun_fact.thb.206_bones',
        length: 33,
      },
      {
        emoji: '⛑🥊 ',
        stringId: 'fun_fact.thb.bacteria_gut',
        length: 98,
      },
      {
        emoji: '❣️💀🔬',
        stringId: 'fun_fact.thb.blood_cells',
        length: 77,
      },
      {
        emoji: '🍗📏🍗',
        stringId: 'fun_fact.thb.femur',
        length: 66,
      },
      {
        emoji: '👅💦🛢',
        stringId: 'fun_fact.thb.saliva',
        length: 64,
      },
      {
        emoji: '🙇🏻💩💩💩🐼',
        stringId: 'fun_fact.thb.poop',
        length: 103,
      },
      {
        emoji: '✊🏽❤️',
        stringId: 'fun_fact.thb.heart_first',
        length: 42,
      },
      {
        emoji: '🤰👶🏽🤱⏲8️⃣',
        stringId: 'fun_fact.thb_baby_born ',
        length: 35,
      },
      {
        emoji: '🍖🍖🍖🍖',
        stringId: 'fun_fact.thb.ribs',
        length: 17,
      },
      {
        emoji: '🍽🗯🥐🌯🍗🍩🍕🍔 ',
        stringId: 'fun_fact.thb.borborygmus',
        length: 56,
      },
      {
        emoji: '🤱👶🏽😢',
        stringId: 'fun_fact.thb.babies_cant_cry',
        length: 35,
      },
      {
        emoji: '😁😒🤭🤪',
        stringId: 'fun_fact.thb.muscles_at_work',
        length: 96,
      },
      {
        emoji: '🧠↪️🧘🏽‍♂️',
        stringId: 'fun_fact.thb.left_controls_right',
        length: 74,
      },
      {
        emoji: '🌫🧠🌫',
        stringId: 'fun_fact.thb.brain_oxygen',
        length: 54,
      },
      {
        emoji: '💅🏽📈💅🏽',
        stringId: 'fun_fact.thb.fingernails',
        length: 39,
      },
    ],
  },
  'simple-machines': {
    'default-emojis': '⛓🛴🔩🚲🏰',
    items: [
      {
        emoji: ' 🏁🏗🎹',
        stringId: 'fun_fact.machines.pulley_examples',
        length: 53,
      },
      {
        emoji: '👹⚒🚪🛑 ',
        stringId: 'fun_fact.machines.wedge_examples',
        length: 70,
      },
      {
        emoji: '🗻📶📈📐',
        stringId: 'fun_fact.machines.inclined_plane_examples',
        length: 57,
      },
    ],
  },
  skyscrapers: {
    'default-emojis': '🏢🏬🏗🏭🏥🏫🌆🌇',
    items: [
      {
        emoji: '🌆🇨🇳🌏',
        stringId: 'fun_fact.skyscrapers.china',
        length: 63,
      },
      {
        emoji: '🏗️🏢',
        stringId: 'fun_fact.skyscrapers.citicorp_center',
        length: 114,
      },
      {
        emoji: '🌬️🚽💦',
        stringId: 'fun_fact.skyscrapers.sway_windstorms',
        length: 108,
      },
      {
        emoji: '🏙🗼📏💠🖇',
        stringId: 'fun_fact.skyscrapers.burj_khalifa',
        length: 105,
      },
      {
        emoji: '⚡️🔌💡⚡️',
        stringId: 'fun_fact.skyscrapers.appliance',
        length: 78,
      },
      {
        emoji: '🔼🎚🏢🔽',
        stringId: 'fun_fact.skyscrapers.fastest_elevator',
        length: 94,
      },
      {
        emoji: '⛴📐',
        stringId: 'fun_fact.skyscrapers.sailing_ship',
        length: 75,
      },
      {
        emoji: '🥇🏗🏢🏙',
        stringId: 'fun_fact.skyscrapers.first',
        length: 96,
      },
      {
        emoji: '🔼📏🇬🇧',
        stringId: 'fun_fact.skyscrapers.shard',
        length: 52,
      },
      {
        emoji: '📏🏢🏙📏👆🏽 ',
        stringId: 'fun_fact.skyscrapers.height',
        length: 75,
      },
      {
        emoji: '🌩⚡️🏢⚡️🌩',
        stringId: 'fun_fact.skyscrapers.empire_state_lightning',
        length: 87,
      },
      {
        emoji: '🗼⏫🌎',
        stringId: 'fun_fact.skyscrapers.eiffel_tower',
        length: 82,
      },
    ],
  },
  mammals: {
    'default-emojis': '🦇🐅🐘🐾🌿',
    items: [
      {
        emoji: '👨‍👩‍👧‍👦👨‍👩‍👧‍👦👨‍👩‍👧‍👦👨‍👩‍👧‍👦',
        stringId: 'fun_fact.mammals.kanga_mob',
        length: 38,
      },
      {
        emoji: '🐘🧠✖️👨🏽🧠👩🏽',
        stringId: 'fun_fact.mammals.elephant_brains',
        length: 61,
      },
      {
        emoji: '🥩🍽🗺',
        stringId: 'fun_fact.mammals.kanga_meat',
        length: 50,
      },
      {
        emoji: '🐘🖇🐘💞 ',
        stringId: 'fun_fact.mammals.elephant_hug',
        length: 44,
      },
      {
        emoji: '🐘🌊 🏊‍♂️👃🏽',
        stringId: 'fun_fact.mammals.elephant_snorkel',
        length: 79,
      },
      {
        emoji: '💩💦👛',
        stringId: 'fun_fact.mammals.kanga_pee_pouch',
        length: 62,
      },
      {
        emoji: '🦇💩🌱🌿',
        stringId: 'fun_fact.mammals.bat_guano',
        length: 39,
      },
      {
        emoji: '🐘👴🏽👵🏽🐘',
        stringId: 'fun_fact.mammals.elephant_age',
        length: 44,
      },
      {
        emoji: '🦇🍼🦇',
        stringId: 'fun_fact.mammals.male_bats_milk',
        length: 28,
      },
      {
        emoji: '🦗🦗🦗🦇🦗🦗🦗',
        stringId: 'fun_fact.mammals.bats_eat_mosquitos',
        length: 44,
      },
      {
        emoji: '🦇🛌 🌨',
        stringId: 'fun_fact.mammals.bat_hibernate',
        length: 35,
      },
      {
        emoji: '🍼🗯 👶👩‍👦',
        stringId: 'fun_fact.mammals.kanga_clicks',
        length: 60,
      },
      {
        emoji: '🐘😥😆',
        stringId: 'fun_fact.mammals.elephant_cry_laugh',
        length: 28,
      },
      {
        emoji: '🐘🙅🏽🤾🏾‍♀️',
        stringId: 'fun_fact.mammals.elephant_cant_jump',
        length: 21,
      },
      {
        emoji: '🐘👓👃🏼👍🏼',
        stringId: 'fun_fact.mammals.elephant_eyesight_smell',
        length: 87,
      },
      {
        emoji: '👟👟👟🦇👟👟👟',
        stringId: 'fun_fact.mammals.bat_wingspan',
        length: 35,
      },
      {
        emoji: '🐘👈🏼👉🏼',
        stringId: 'fun_fact.mammals.right_left_tusked',
        length: 79,
      },
      {
        emoji: '🌳🏑🌳',
        stringId: 'fun_fact.mammals.claws',
        length: 55,
      },
      {
        emoji: '🥩🍗🍖🥦🍏🥕',
        stringId: 'fun_fact.mammals.carnivore_herbivore',
        length: 75,
      },
      {
        emoji: '🐘😬📏◽️',
        stringId: 'fun_fact.mammals.elephant_molars',
        length: 54,
      },
      {
        emoji: '🐘📏🔬',
        stringId: 'fun_fact.mammals.elephant_skin',
        length: 48,
      },
      {
        emoji: '🕕🍽🕗🌱🗓🌿',
        stringId: 'fun_fact.mammals.sloth_digest',
        length: 99,
      },
      {
        emoji: '🐘🐫🦒🐄🐎🐖🐏🦌🐕🐈',
        stringId: 'fun_fact.mammals.5000_species',
        length: 40,
      },
      {
        emoji: '🦇🖤💨',
        stringId: 'fun_fact.mammals.bat_heart_lungs',
        length: 70,
      },
      {
        emoji: '🏃‍♀️🏃‍♂️🐅🐆🦓🐎',
        stringId: 'fun_fact.mammals.animals_humans_run',
        length: 80,
      },
      {
        emoji: '🐘👶🏽🚶🏽‍♀️🚶🏽',
        stringId: 'fun_fact.mammals.elephant_newborn_walk',
        length: 56,
      },
      {
        emoji: '👶🏽🐘🏋🏾‍♀️',
        stringId: 'fun_fact.mammals.elephant_newborn_weight',
        length: 43,
      },
      {
        emoji: '🐀💀🐅',
        stringId: 'fun_fact.mammals.predatory_prey',
        length: 70,
      },
      {
        emoji: '🌾🎒🏆🇦🇺🌾 ',
        stringId: 'fun_fact.mammals.red_kanga_largest',
        length: 51,
      },
      {
        emoji: '🐘🏞🙌🏽🥇',
        stringId: 'fun_fact.mammals.elephant_largest',
        length: 47,
      },
      {
        emoji: '👀 🌚🌅🌄🌝👀 ',
        stringId: 'fun_fact.mammals.nocturnal_diurnal',
        length: 87,
      },
      {
        emoji: '🌾🌙☀️🌾',
        stringId: 'fun_fact.mammals.kanga_nocturnal_diurnal',
        length: 39,
      },
      {
        emoji: '🐅🏑',
        stringId: 'fun_fact.mammals.tiger_tongues',
        length: 92,
      },
      {
        emoji: '🐘🥢⚔️',
        stringId: 'fun_fact.mammals.elephant_tusks',
        length: 51,
      },
      {
        emoji: '🐘🐱〰️',
        stringId: 'fun_fact.mammals.elephant_purr',
        length: 25,
      },
    ],
  },
  weather: {
    'default-emojis': '☀️🌤⛅️🌥☁️🌦🌧⛈🌩🌨❄️🌈',
    items: [
      {
        emoji: '🌪⏩🌬💨',
        stringId: 'fun_fact.weather.tornado_winds',
        length: 100,
      },
      {
        emoji: '🌧⚽️🌨',
        stringId: 'fun_fact.weather.hailstones',
        length: 78,
      },
      {
        emoji: '🇨🇱☁️🙏🏽💦 ',
        stringId: 'fun_fact.weather.chile_drought',
        length: 79,
      },
      {
        emoji: '🌫️🌫️🌫️🌫️🌫️🌫️',
        stringId: 'fun_fact.weather.atmosphere',
        length: 114,
      },
      {
        emoji: '🌪💥📏 ',
        stringId: 'fun_fact.weather.tornadoes_destroy_instruments',
        length: 72,
      },
      {
        emoji: '🌊🌪 💦',
        stringId: 'fun_fact.weather.waterspouts',
        length: 48,
      },
      {
        emoji: '⛈🌎⛈🌍⛈🌏 ',
        stringId: 'fun_fact.weather.2000.thunderstorms',
        length: 60,
      },
      {
        emoji: '🌪 ⏩ 🗺📍',
        stringId: 'fun_fact.weather.tornado_speed',
        length: 74,
      },
      {
        emoji: ' 🌩️⛈️🌩️🌪️🌩️🌨️🌩️',
        stringId: 'fun_fact.weather.thunderstorms',
        length: 50,
      },
    ],
  },
  space: {
    'default-emojis': '🌌🚀🌍🌎🌏🛰☄️💫🌙',
    items: [
      {
        "emoji": "👶🏽🌑",
        "stringId": "fun_fact.space.pluto_ninth",
        "length": 105
      },
      {
        emoji: '⚡️⚡️⛈⚡️⚡️',
        stringId: 'fun_fact.space.venus_thunderstorms',
        length: 92,
      },
      {
        emoji: '🌑🌑🌑🤹🏽‍♂️🌑🌑🌑',
        stringId: 'fun_fact.space.saturn_60_moons',
        length: 68,
      },
      {
        emoji: '🌫🔴😷',
        stringId: 'fun_fact.space.mars_dust_storms',
        length: 56,
      },
      {
        emoji: '⚪️🥈🔥',
        stringId: 'fun_fact.space.mercury_second_hottest',
        length: 83,
      },
      {
        emoji: '🔵➰🔭 ',
        stringId: 'fun_fact.space.uranus_mysterious',
        length: 99,
      },
      {
        emoji: '🌕💡✨🔴',
        stringId: 'fun_fact.space.venus_bright',
        length: 68,
      },
      {
        emoji: '🌋🥇🌕💫🔭 ',
        stringId: 'fun_fact.space.olympus_mons',
        length: 76,
      },
      {
        emoji: '🌎🌍🌏❌👌🏽🔵',
        stringId: 'fun_fact.earth.roundish',
        length: 35,
      },
      {
        emoji: '🗻👆🏼🏔',
        stringId: 'fun_fact.space.mount_everest_io',
        length: 76,
      },
      {
        emoji: '🌓🌔🔵🌖🌗',
        stringId: 'fun_fact.space.uranus_moons_hakespeare',
        length: 67,
      },
      {
        emoji: '💍🔵💍',
        stringId: 'fun_fact.space.uranus_rings',
        length: 71,
      },
      {
        emoji: '💫💫💫🔵💫💫💫',
        stringId: 'fun_fact.space.uranus_year',
        length: 50,
      },
      {
        emoji: '🌙🌙🌙❄️🌙🌙🌙',
        stringId: 'fun_fact.space.saturn_moons_moonlets',
        length: 71,
      },
      {
        emoji: '⏳🌕🔭⏳',
        stringId: 'fun_fact.space.venus_day',
        length: 52,
      },
      {
        emoji: '🔴💫🔄🕙',
        stringId: 'fun_fact.space.jupiter_short_days',
        length: 106,
      },
      {
        emoji: '🔭🌌🌌🌌🌌🌌🔭 ',
        stringId: 'fun_fact.space.milky_way',
        length: 106,
      },
      {
        emoji: '🌕👌🏽📏',
        stringId: 'fun_fact.space.mercury_smallest',
        length: 52,
      },
      {
        emoji: '🔥🔥🌡🌕🌡🔥🔥 ',
        stringId: 'fun_fact.space.enceladus_geysers',
        length: 73,
      },
      {
        emoji: '🌕💦',
        stringId: 'fun_fact.space.enceladus_geysers',
        length: 76,
      },
      {
        "emoji": "🌍🌃🌎🌉🌏🌌",
        "stringId": "fun_fact.space.lights_from_space",
        "length": 65
      },
      {
        "emoji": "🌕🌊〰️🌫🔥",
        "stringId": "fun_fact.space.venus_oceans",
        "length": 71
      }
    ]
  },
  "states-of-matter": {
    "default-emojis": " ❄️🔥💧🔥🌫🔃",
    "items": [
      {
        "emoji": "⚡☀️ ",
        "stringId": "fun_fact.matter.plasma_electrified_gas",
        "length": 112
      },
      {
        "emoji": "🔬2️⃣👩🏽‍🔬",
        "stringId": "fun_fact.matter.two_properties",
        "length": 56
      },
      {
        "emoji": "🏔️🚰⌛♨️ 🏖🚰⏳",
        "stringId": "fun_fact.matter.water_boils",
        "length": 139
      },
      {
        "emoji": "👀👤",
        "stringId": "fun_fact.matter.shadow_see",
        "length": 56
      },
      {
        "emoji": "👀🌫🌫🌫👀",
        "stringId": "fun_fact.matter.see_through_solids",
        "length": 42
      },
      {
        "emoji": "🌎💦🚰🤽🏾🏊🏽‍♂️🏄🚣🏖🏝🌊💧🚿🛁",
        "stringId": "fun_fact.matter.two_thirds",
        "length": 59
      },
      {
        "emoji": "🔑🥇🔔🏆👑🍿❄🔧🕒🔪🔨✂💠",
        "stringId": "fun_fact.matter.cut_up",
        "length": 33
      },
      {
        "emoji": "🌡️🇸🇪",
        "stringId": "fun_fact.matter.celsius_swedish",
        "length": 78
      },
      {
        "emoji": "🌊🚣⛸️🏒❄️🌡 ",
        "stringId": "fun_fact.matter.fresh_salt_water",
        "length": 79
      },
      {
        "emoji": "🌡️✋🌡️",
        "stringId": "fun_fact.matter.gallium_melting_point",
        "length": 86
      },
      {
        "emoji": "🇸🇪🔭🌎 ",
        "stringId": "fun_fact.matter.celsius_named",
        "length": 140
      },
      {
        "emoji": "🔑🥇🔔🏆👑🍿❄🔧🕒🎈🌬🌫💨💦🚰",
        "stringId": "fun_fact.matter.periodic_table",
        "length": 124
      },
      {
        "emoji": "💦💦💦💦💦💦🍖🧠🙆‍♀️",
        "stringId": "fun_fact.matter.adult_human",
        "length": 31
      },
      {
        "emoji": "🔴 🔴",
        "stringId": "fun_fact.matter.solids_space",
        "length": 50
      },
      {
        "emoji": "⛏️🌫🌫🌫🎈",
        "stringId": "fun_fact.matter.helium_dig",
        "length": 99
      },
      {
        "emoji": "💛💉💛",
        "stringId": "fun_fact.matter.bodies_gold",
        "length": 76
      },
      {
        "emoji": "🌫🔥🌫",
        "stringId": "fun_fact.matter.fire_gases",
        "length": 31
      },
      {
        "emoji": "🌫🧖🌁🍲🌋🥟☕🍵🏭🎈🥧",
        "stringId": "fun_fact.matter.gases_all_around",
        "length": 57
      },
      {
        "emoji": "🌌🌫🥈🌎",
        "stringId": "fun_fact.matter.helium_earth",
        "length": 96
      },
      {
        "emoji": "🇱🇾🔥🖍️🕯️",
        "stringId": "fun_fact.matter.libya_temperature",
        "length": 101
      },
      {
        "emoji": "🍫🔥🐇",
        "stringId": "fun_fact.matter.chocolate_bunnies",
        "length": 90
      },
      {
        "emoji": "💧💦🌧",
        "stringId": "fun_fact.matter.millions_drop",
        "length": 63
      },
      {
        "emoji": "🌫🔬",
        "stringId": "fun_fact.matter.bromine_discovered",
        "length": 52
      },
      {
        "emoji": "🌡️🍄☠️☠️",
        "stringId": "fun_fact.matter.fahrenheit_invented",
        "length": 159
      },
      {
        "emoji": "🌡️🏃‍♂️🚀",
        "stringId": "fun_fact.matter.temperature_measure",
        "length": 117
      },
      {
        "emoji": "🌬🌫💨",
        "stringId": "fun_fact.matter.different_gases",
        "length": 47
      },
      {
        "emoji": "🌌⭐🌌⭐🌌⭐🌌 ",
        "stringId": "fun_fact.matter.stars_plasma",
        "length": 50
      },
      {
        "emoji": "💎☝️💎",
        "stringId": "fun_fact.matter.diamonds_carbon ",
        "length": 131
      },
      {
        "emoji": "🛣❄️🚗🚕🚙🚌🚓🚑🚒🚐🚚🚜🚲🛵 ",
        "stringId": "fun_fact.matter.salt_roads",
        "length": 94
      },
      {
        "emoji": "🌲🔴     🔴 🥇🔴 🔴 ",
        "stringId": "fun_fact.matter.density_molecules",
        "length": 155
      },
      {
        "emoji": "🏋️🥇🏗️🏆👑",
        "stringId": "fun_fact.matter.gold_bar",
        "length": 52
      },
      {
        "emoji": "🌋🌋🌋",
        "stringId": "fun_fact.matter.heat_pressure",
        "length": 119
      },
      {
        "emoji": "🌌🌫🎈🔭🇫🇷☄️🌃🧐👴",
        "stringId": "fun_fact.matter.helium_detected",
        "length": 70
      },
      {
        "emoji": " 🙆‍♀️🙆‍♂️👨🏿 🎆🎇🏜🌋⛰🏔🗻🌎🌍🌔🐶🦁",
        "stringId": "fun_fact.matter.everything_matter",
        "length": 56
      },
      {
        "emoji": "⛏️💎⛏️",
        "stringId": "fun_fact.matter.diamonds_hard",
        "length": 91
      },
      {
        "emoji": "💨💧💨",
        "stringId": "fun_fact.matter.liquid_oxygen",
        "length": 92
      },
      {
        "emoji": "🕺💃💧💨✊",
        "stringId": "fun_fact.matter.humans_made_matter",
        "length": 113
      },
      {
        "emoji": "👩‍🔬👨🏿‍🔬",
        "stringId": "fun_fact.matter.new_states",
        "length": 74
      },
      {
        "emoji": "🐘🐁",
        "stringId": "fun_fact.matter.amount_matter",
        "length": 48
      },
      {
        "emoji": "0️⃣✊",
        "stringId": "fun_fact.matter.absolute_zero",
        "length": 156
      },
      {
        "emoji": "🌫🎈🎈🎈🎈🌫",
        "stringId": "fun_fact.matter.helium_light",
        "length": 116
      },
      {
        "emoji": "💥💥💥",
        "stringId": "fun_fact.matter.big_bang",
        "length": 82
      },
      {
        "emoji": "🌌🌫🎈🎈🎈🎈",
        "stringId": "fun_fact.matter.helium_common",
        "length": 120
      },
      {
        "emoji": "🥉⚗🗑️📎💡🛒🌔🕸",
        "stringId": "fun_fact.matter.ductile_materials",
        "length": 138
      },
      {
        "emoji": "🌫👃❌",
        "stringId": "fun_fact.matter.broming_foul",
        "length": 45
      },
      {
        "emoji": "🌡️🌎 🌡️🌎",
        "stringId": "fun_fact.matter.fahrenheit_celsius",
        "length": 107
      },
      {
        "emoji": "👨‍🔬🌫⚗📸👩‍🔬🎞",
        "stringId": "fun_fact.matter.bromine_dyes",
        "length": 53
      }
    ]
  }
};
